import { inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import type { ResolveFn } from '@angular/router';
import { chain } from 'lodash';
import type { PartialDeep } from 'type-fest';
import { CacheService } from '../../../../common/services/cache.service';
import type { DelegationFormResolverData } from '../../delegations.routes';
import { DelegationsQueryParamKey } from '../enums/delegations-query-param-key';
import { DelegationsStorageKey } from '../enums/delegations-storage-key';
import type { DelegationForm } from '../helpers/delegation-form.helper';
import { DelegationFormHelper } from '../helpers/delegation-form.helper';

export const addDelegationResolver: ResolveFn<DelegationFormResolverData> = (
  route,
) => {
  const cacheService = inject(CacheService);
  const fb = inject(NonNullableFormBuilder);

  const cacheKey = DelegationsStorageKey.ADD_DELEGATION_FORM;
  const cache = cacheService.get<PartialDeep<DelegationForm>>(cacheKey, {
    keepOnNavigation: true,
  });

  const driverAndVehicle = chain(DelegationsQueryParamKey)
    .values()
    .map((key) => [key, route.queryParamMap.get(key)])
    .filter(([_, value]) => !!value)
    .fromPairs()
    .value();

  const form = DelegationFormHelper.buildForm(fb);
  const baseForm = form.getRawValue();
  const initial: PartialDeep<DelegationForm> = {
    ...baseForm,
    ...(Object.entries(driverAndVehicle).length && { driverAndVehicle }),
  };

  return {
    form: cache
      ? {
          ...cache,
          ...(Object.entries(driverAndVehicle).length && { driverAndVehicle }),
        }
      : initial,
    initial,
  };
};
